/* eslint-disable react/prop-types */
import React from "react";
import { Button, Alert } from "react-bootstrap";
//Images and Icons
import { MdOutlineCancel } from "react-icons/md";

const StatusBlock = (props) => {
    const dismiss = () => {
      props.dismissMessages();
    };
  
    if (props.errorMessage !== "") {
      return (
        <Alert variant='danger' className='mt-3 text-center'>
          {props.errorMessage}{" "}
          <Button variant='secondary' size='sm' onClick={dismiss}>
            dismiss <MdOutlineCancel />
          </Button>
        </Alert>
      );
    } else if (props.successMessage !== "") {
      return (
        <Alert variant='success' className='mt-3 text-center'>
          {props.successMessage}{" "}
          <Button variant='secondary' size='sm' onClick={dismiss}>
            dismiss <MdOutlineCancel />
          </Button>
        </Alert>
      );
    } else {
      return " ";
    }
  };

  export default StatusBlock;